import { toast } from "react-toastify";
import api from "./api/api";

const inFlightListarDesks = new Map<string, Promise<any>>();

function stableStringify(value: any): string {
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(",")}]`;
  }

  if (value && typeof value === "object") {
    return `{${Object.keys(value)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`)
      .join(",")}}`;
  }

  return JSON.stringify(value);
}

const CadastroDeskService = {
  cadastrarDesk: async (payload: any) => {
    try {
      const res = await api.post(`/desk`, payload);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  listarDesks: async (payload: any, config?: any) => {
    const shouldDedupe = !config?.signal;
    const requestKey = shouldDedupe ? stableStringify(payload) : "";

    if (shouldDedupe && inFlightListarDesks.has(requestKey)) {
      return inFlightListarDesks.get(requestKey);
    }

    const requestPromise = api
      .post(`/desk/filtro`, payload, config)
      .catch((error: any) => {
        if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
          throw error;
        }
        return error.response;
      })
      .finally(() => {
        if (shouldDedupe) {
          inFlightListarDesks.delete(requestKey);
        }
      });

    if (shouldDedupe) {
      inFlightListarDesks.set(requestKey, requestPromise);
    }

    try {
      return await requestPromise;
    } catch (error) {
      throw error;
    }
  },
  getDesk: async (id_desk: any) => {
    try {
      const res = await api.get(`/desk/${id_desk}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteDesk: async (id_desk: any) => {
    try {
      const res = await api.delete(`/desk/${id_desk}`);
      toast.success("Deletado com sucesso!");
      return res;
    } catch (error: any) {
      toast.error("Erro ao deletar!");
      return error.response;
    }
  },
  EditarDesk: async (id: number, payload: any, editarValorPdi = false) => {
    // Atualizações rápidas podem enviar uma cópia desatualizada da desk.
    if (payload instanceof FormData) {
      payload.delete("editar_valor_pdi");
      if (editarValorPdi && payload.has("valor_pdi")) {
        payload.set("editar_valor_pdi", "true");
      } else {
        payload.delete("valor_pdi");
      }
    } else {
      payload = { ...payload };
      delete payload.editar_valor_pdi;
      if (editarValorPdi && payload.valor_pdi !== undefined) {
        payload.editar_valor_pdi = true;
      } else {
        delete payload.valor_pdi;
      }
    }
    try {
      if (payload.files !== undefined) {
        const res = await api.put(`/desk/${id}`, payload);
        return res;
      } else {
        delete payload.files;
        const res = await api.put(`/desk/${id}`, payload);
        return res;
      }
    } catch (error: any) {
      return error.response;
    }
  },
  getProdutosCriacao: async () => {
    try {
      const res = await api.get(`/produtosSteakholder/valores`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listarCampanhasPublicitaria: async (desk: string, idCampanha: any) => {
    try {
      const res = await api.get(
        `/campanhas-publicitarias?nome=${desk}&id=${idCampanha}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  batchDesks: async (payload: {
    ids: number[];
    action: string;
    payload?: Record<string, any>;
  }) => {
    try {
      const res = await api.patch(`/desks/batch`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  criarRascunho: async (payload: any) => {
    try {
      const res = await api.post(`/desk/rascunho`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  autoSaveRascunho: async (id: number, payload: Record<string, any>) => {
    try {
      const res = await api.patch(`/desk/${id}/rascunho`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  listarRascunhos: async () => {
    try {
      const res = await api.get(`/desk/rascunhos`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deletarRascunho: async (id: number) => {
    try {
      const res = await api.delete(`/desk/${id}/rascunho`);
      toast.success("Rascunho deletado!");
      return res;
    } catch (error: any) {
      toast.error("Erro ao deletar rascunho!");
      return error.response;
    }
  },
  publicarRascunho: async (id: number, payload: any) => {
    try {
      const res = await api.post(`/desk/${id}/publicar`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default CadastroDeskService;
